import { defineMessages } from 'react-intl'

const scope = 'component.layout.tabs.HeaderTabs'

export default defineMessages({
  dashboard: {
    id: `${scope}.dashboard`,
    defaultMessage: 'Dashboard'
  },
  referralsList: {
    id: `${scope}.referrals-list`,
    defaultMessage: 'Referrals list'
  },
  clinicsList: {
    id: `${scope}.clinics-list`,
    defaultMessage: 'Clinics list'
  }
})
